import { CalculatedUploadState } from './useCalculatedUploadState';
import { Alert, Red80 } from '@traceair/tds';
import { stylesheet } from 'typestyle';
import { InterruptedUploadIcon } from '../../../../../images/components/InterruptedUploadIcon';

const css = stylesheet({
  container: {
    marginTop: 8,
  },
});

interface Props {
  scanState: CalculatedUploadState | null;
  panoState: CalculatedUploadState | null;
}

export const MissionUploadInterrupted = ({ scanState, panoState }: Props) => {
  const isScanInterrupted = scanState === CalculatedUploadState.Interrupted;
  const isPanoInterrupted = panoState === CalculatedUploadState.Interrupted;

  if (!isScanInterrupted && !isPanoInterrupted) {
    return null;
  }

  let title = '';
  if (isScanInterrupted && isPanoInterrupted) {
    title = 'Scan and panorama uploads incomplete';
  } else if (isScanInterrupted) {
    title = 'Scan upload incomplete';
  } else if (isPanoInterrupted) {
    title = 'Panorama upload incomplete';
  }

  return (
    <Alert
      className={css.container}
      icon={<InterruptedUploadIcon color={Red80} />}
      type="warning"
      title={title}
      description="Please upload the missing files"
    />
  );
};
